import { createRoot } from 'react-dom/client';
import App from './App.jsx';

const saved = localStorage.getItem('bf_theme');
document.documentElement.dataset.theme = saved === 'light' ? 'light' : 'dark';

createRoot(document.getElementById('root')).render(<App />);

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register(new URL('sw.js', import.meta.url))
    .catch((err) => console.error('Impossible d’enregistrer le service worker', err));
}
